<div mat-dialog-title class="grid">
  <div class="column-title">
    <span class="title">{{ data.title }}</span>
  </div>
  <div class="column-close changecolorclose">
    <button mat-button (click)="closeDialog()">
      <mat-icon class="material-icons-outlined icon-close">close</mat-icon>
    </button>
  </div>
  <div class="column-sutitle">
    <span class="subtitle">Esto es lo que estuvo pasando en el Handover</span>
  </div>
</div>
<div class="observations-dialog" mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let observation of data.observations">
      <div class="grid-ho">
        <div class="grid-ho-item grid-ho-item1">
          <span class="observation-type">{{ observation.handoverObservationTypeDescription }}: </span>
          <span class="observation" [title] = "observation.receiverObservation">"{{ observation.receiverObservation }}"</span>
        </div>
        <div class="grid-ho-item grid-ho-item2">
          <span class="observation-date">Actualización de dato al {{ observation.receiverObservationDatetime }}:</span>
        </div>
        <div class="grid-ho-item grid-ho-item3">
          <div *ngIf="observation.emitterObservationSolved == null">
            <span class="emitter-name">
              {{ data.handoverTypeId != HO3 ? data.emitterName : '' }} 
              {{ data.handoverTypeId == HO3 ? observation.departmentObservation == OPERATIONS_DO ? data.emitterName : data.engineerEmitterName : '' }} 
              indica: 
            </span>
            <mat-icon class="ho-pending" svgIcon="ho-pending.svg"></mat-icon>
            <span class="observation-pending">Pendiente por resolver</span>
          </div>
          <div *ngIf="observation.emitterObservationSolved != null && observation.emitterObservationSolved">
            <span class="emitter-name">{{ observation.emitterName }} indica: </span>
            <mat-icon class="check-fill-green" svgIcon="check-fill-green"></mat-icon>
            <span class="observation-resolved" *ngIf="observation.emitterObservationSolved">Se pudo resolver</span>
          </div>
          <div *ngIf="observation.emitterObservationSolved != null && !observation.emitterObservationSolved">
            <span class="emitter-name">{{ observation.emitterName }} indica: </span>
            <mat-icon class="check-fill-red" svgIcon="close-fill-red"></mat-icon>
            <span class="observation-not-resolved" *ngIf="!observation.emitterObservationSolved">No se pudo resolver</span>
          </div>
        </div>
        <div *ngIf="observation.emitterObservation != null" class="grid-ho-item grid-ho-item4">
          <span class="emitter-name">Y comenta: </span><span class="observation"  [title] = "observation.emitterObservation">"{{ observation.emitterObservation }}"</span>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
<div mat-dialog-actions>
  <button mat-button class="no-button" (click)="closeDialog()">Cerrar</button>
</div>